import { useEffect, useState } from 'react';
import { useContextAdminHora } from '../ContextAdminHorario';
import { eliminaHorario, obtenerDetalleHorario } from '../../../services/HorarioTurno/TurnoService';

export const useEliminaHorario = (datosHorario, ocultaDialogElimina) => {
    const { horarioId, nombre, sigla } = datosHorario;
    const [cargaDetHorario, setCargaDetHorario] = useState(true);
    const [lstDetHorario, setLstDetHorario] = useState([]);
    const [procesa, setProcesa] = useState(false);

    const showToast = useContextAdminHora();

    useEffect(() => {
        const cargaDetalle = async () => {
            try {
                setCargaDetHorario(true);
                const response = await obtenerDetalleHorario(horarioId);
                setLstDetHorario(response);
            } catch (error) {
                console.error(error.message);
            } finally {
                setCargaDetHorario(false);
            }
        };
        cargaDetalle();
    }, []);

    const formatoHora = (objTime) => {
        if (!objTime) return '';
        const { hour, minute } = objTime;
        const hora = String(hour).padStart(2, '0');
        const minuto = String(minute).padStart(2, '0');
        return `${hora}:${minuto}`;
    };

    const horaInicioTemplate = (filaData) => {
        return formatoHora(filaData.horaInicio);
    };
    const horaFinalTemplate = (filaData) => {
        return formatoHora(filaData.horaFin);
    };

    const handleEliminaHorario = async () => {
        try {
            setProcesa(true);
            const response = await eliminaHorario(horarioId);
            //mensajeExitoProceso();
            showToast('success', 'Success', 'Proceso ejecutado con exito');
        } catch (error) {
            console.error('Error al Borrar');
            //mensajeErrorProceso('Se ha producido un Error y no se ha borrado')
            showToast('error', 'Error', 'Se ha producido un Error y no se ha borrado');
        } finally {
            setProcesa(false);
            ocultaDialogElimina();
        }
    };

    return { nombre, sigla, cargaDetHorario, lstDetHorario, horaInicioTemplate, horaFinalTemplate, handleEliminaHorario, procesa };
};
